import React, { Component } from 'react';
import ScaleRadioButton from 'components/ScaleRadioButton/ScaleRadioButton';
import { globalData } from 'global/js/globalData';
import './ScaleRadioButtonList.scss';

const ScaleRadioButtonList = (props) => {
    /**
     * Constructs the list of scale radio buttons used for customer feedback.
     * One button for each possible scale value.
     */
    const buildRadioButtons = () => {
        const scaleAnswerTypes = props.isFourScale ? [1, 2, 3, 4] : [1, 2, 3, 4, 5];
        // Construct a list of radio buttons for each scale rating option.
        const scaleRatings = scaleAnswerTypes.map((answer) => {
            const scaleRatingId = 'scale' + answer;
            const scaleRatingLabel = props.isFourScale ? 
                globalData.fourScaleLabelText[answer - 1] : 
                globalData.fiveScaleLabelText[answer - 1];

            return (
                <ScaleRadioButton
                    htmlFor={scaleRatingId}
                    isChecked={props.answerValue === answer}
                    key={scaleRatingId}
                    onChange={handleChange}
                    radioButtonId={scaleRatingId}
                    scaleRatingLabel={scaleRatingLabel}
                    title={scaleRatingLabel}
                    scaleValue={answer}
                />
            );
        });

        return <div className='scales'>{scaleRatings}</div>;
    };

    /**
     * Called when a scale input value is clicked. This function gets the
     * value attribute of the scale/input and sets the state with it.
     *
     * @param     event : {Native Event Object}
     */
    const handleChange = (event) => {
        const value = parseInt(event.target.value);

        if (props.questionType) {
            props.handleClick({
                type: props.questionType,
                rating: value,
                tdIndex: props.tdIndex
            });
        } else {
            props.handleClick(value);
        }
    };

    return (
        <div className='scale-rating-wrapper'>
            {buildRadioButtons()}
        </div>
    );
};

export default ScaleRadioButtonList;



// WEBPACK FOOTER //
// ./application/components/ScaleRadioButtonList/ScaleRadioButtonList.jsx